export const HOW_RENT = {
  Header: '¿Qué necesitas para rentar?',
  Body: [
    {
      Title: 'Identificación:',
      Paragraphs: [
        `Debes presentar los siguientes documentos de identificación para poder rentar y 
        retirar posteriormente el vehículo en la locación que selecciones:`,
        `Identificación oficial para las reservaciones cuyo punto de recogida y entrega 
        esté dentro del territorio nacional. Pasaporte válido para las reservaciones fuera 
        de México y para extranjeros que renten un auto en México.`,
        `Licencia de conducir vigente y con una antigüedad mínima de 2 años al momento de 
        retirar el auto. En caso que la licencia de conducir esté vencida, la rentadora 
        puede negar la prestación del servicio contratado. Esta condición aplica para las 
        reservaciones locales e internacionales.`,
      ]
    },
    {
      Title: 'Bloqueo de tarjeta:',
      Paragraphs: [
        `Como conductor principal debes contar con una tarjeta de crédito física, la cual debe estar a tu nombre y 
        tener los datos de la tarjeta impresos en ella; recuerda que las rentadoras no aceptan tarjetas de crédito 
        digitales y que solamente puedes presentar una tarjeta física que corresponda a las franquicias Visa, 
        American Express, Dinners Club o MasterCard. La rentadora realizará un bloqueo por un monto específico 
        a modo de garantía, esto puede variar dependiendo de la rentadora y el tipo de auto contratado; el monto 
        retenido en la tarjeta será liberado al momento de devolver el auto.`
      ],
      Conditions: [
        {
          ExcludedCompanies: ['avasaregular'],
          Paragraphs: [
            `Como conductor principal debes contar con una tarjeta de crédito física, la cual debe 
            estar a tu nombre y tener los datos de la tarjeta impresos en ella; recuerda que las 
            rentadoras no aceptan tarjetas de crédito digitales.`,
            `La rentadora realizará un bloqueo por un monto específico a modo de garantía, esto puede 
            variar dependiendo la rentadora y el tipo de auto contratado; el monto retenido en la 
            tarjeta será liberado al momento de devolver el auto.`
          ]
        }
      ]
    },
    {
      Title: 'Restricción de edad:',
      Paragraphs: [
        `La edad mínima para rentar un auto es de 18 años, y la edad máxima es de 65 años. 
        Si tienes entre 18 y 25 años, o si eres mayor de 65 años, la rentadora te hará un cobro 
        referente a un seguro adicional, el cual deberás pagar en el mostrador de la rentadora.`,
      ]
    }
  ]
};
